// extracted by mini-css-extract-plugin
module.exports = {"note":"OrderRefundNote_note__1OZbS"};